import { getInitialWindowMetrics } from "../platform/safe-area";
var initialWindowMetrics = getInitialWindowMetrics();
var initialWindowSafeAreaInsets = initialWindowMetrics === null || initialWindowMetrics === void 0 ? void 0 : initialWindowMetrics.insets;
export {
  initialWindowMetrics,
  initialWindowSafeAreaInsets
};
//# sourceMappingURL=InitialWindow.native.js.map
